<template>
	<div class="checklist-container">
		<div class="checklist-row" v-for="(item, index) in items">
			<div class="checklist-row-header" :class="{pointer: isClickable(item)}" @click="clickDropdown(index)">
				<div class="check" :class="{active: item.completed}">
					<div v-html="getIcon('iconV')" />
				</div>
				<h4 class="checklist-row-title">{{ item.title }}</h4>
				<div class="chevron-icon"><AppChevronIcon :size="18" :direction="currentOpenDropdown !== index ? 'down' : 'up'" /></div>
			</div>
			<div class="checklist-row-content">
				<AppDropdown white :collapsed="currentOpenDropdown !== index">
					<slot v-if="item.slotName" :name="item.slotName" :itemStep="item"></slot>
				</AppDropdown>
			</div>
		</div>
	</div>
</template>

<script>
import AppDropdown from "@/shared/components/AppDropdown.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";

import { useSvgStore } from "@/shared/stores";

export default {
	setup() {
		const svgStore = useSvgStore();
		return { getIcon: svgStore.get };
	},
	props: {
		items: {
			type: Array,
			default: () => [],
		}
	},
	data() {
		return {
			currentOpenDropdown: null,
		}
	},
	name: "StepsBottomSheetChecklist",
	components: {AppChevronIcon, AppDropdown},
	methods: {
		clickDropdown(index) {
			if(!this.items[index].completed && !this.isClickable(this.items[index])) {
				return;
			}
			if(this.currentOpenDropdown !== index) {
				this.currentOpenDropdown = index;
			}
		},
		isClickable(item) {
			if(this.items.indexOf(item) === this.currentOpenDropdown) {
				return false;
			}
			if(item.completed) {
				return true;
			}
			let currentCompleted = -1;
			for (let i = 0; i < this.items.length; i++) {
				if(this.items[i].completed) {
					currentCompleted = i;
				} else {
					break;
				}
			}
			return this.items[currentCompleted + 1] === item;
		},
		initDropdown() {
			if(!this.items?.[0]) {
				return;
			}
			let currentCompleted = -1;
			for (let i = 0; i < this.items.length; i++) {
				if(this.items[i].completed) {
					currentCompleted = i;
				} else {
					break;
				}
			}
			if(currentCompleted !== -1 && this.items[currentCompleted + 1]) {
				this.currentOpenDropdown = currentCompleted + 1;
			} else if(currentCompleted === -1) {
				this.currentOpenDropdown = 0;
			} else {
				this.currentOpenDropdown = null;
			}
		}
	},
	mounted() {
		this.initDropdown();
	},
	watch: {
		items(newValue) {
			if(this.currentOpenDropdown === null || !newValue?.[this.currentOpenDropdown]) {
				return
			}
			let currStep = this.items[this.currentOpenDropdown];
			if(currStep.completed) {
				this.currentOpenDropdown = !newValue?.[this.currentOpenDropdown + 1] ? null : this.currentOpenDropdown + 1;
			}
		}
	}
}

</script>

<style scoped lang="scss">
.checklist-container {
	width: 360px;
	max-width: 100%;
	.checklist-row {
		margin: 8px 0;
	}

	.checklist-row-header {
		@include centered;
		justify-content: space-between;
		text-align: left;

		&.pointer {
			cursor: pointer;
		}

		.checklist-row-title {
			font-size: 14px;
		}

		.check {
			@include centered;
			width: 26px;
			height: 26px;
			border-radius: 8px;
			border: 1px solid var(--color-primary);
			margin-right: 5px;

			:deep(svg) {
				width: 12px;
				height: 12px;
				stroke: #fff;
				display: none;
			}

			&.active {
				background-color: rgb(72,152,116);
				border: none;
				:deep(svg) {
					display: block;
				}
			}
		}
		h4 {
			width: calc(100% - 70px);
			font-style: normal;
			color: var(--color-primary);
		}
		.chevron-icon {
			@include centered;
			width: 34px;
			height: 34px;
			border-radius: 8px;
			margin-left: 5px;
			background-color: var(--color-alpha-1);
		}
	}
	.checklist-row-content {
		.checklist-dropdown-content {
			padding: 20px;
		}
	}

}
</style>